import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { notification } from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import NotificationStreamService from '../../services/notificationStream';
import { toLower } from '../../util/lodashlike';
import { TRANSACTION_HISTORY_MODULES as MODULES } from '../constants/commonConstants';
import { navigateWithRefresh } from './Topbar/notifications/notificationNavigation';
import { resolveNotificationTarget } from './Topbar/notifications/resolveNotificationTarget';

const NotificationListener = ({ history, moduleId }) => {
  const serviceRef = useRef(null);

  useEffect(() => {
    const service = new NotificationStreamService({
      moduleId,
      onMessage: (event) => {
        if (event.eventType !== 'async_download') return;
        console.log('Notification received:', event);

        const {
          status,
          exportName,
          errorReason,
          caseId,
          downloadType,
          module
        } = event;

        // FIN-13571 — same target as the bell dropdown (resolveNotificationTarget). The toast
        // used to carry its own copy of the routing with no activity branch, so clicking an
        // activity-export toast did nothing.
        const navigateToTarget = () => {
          const target = resolveNotificationTarget(event);
          if (target) navigateWithRefresh({ history, ...target });
          notification.destroy();
        };

        const statusLower = toLower(status);
        const notifyConfig = {
          completed: {
            type: 'success',
            message: 'Export Completed',
            description: exportName
          },
          inprogress: {
            type: 'info',
            message: 'Export Inprogress',
            description: exportName
          },
          failed: {
            type: 'error',
            message: 'Export Failed',
            description: errorReason || exportName
          }
        };

        // Trigger refresh of download history if user is on the corresponding page
        if (
          (module === MODULES.CM_CASE_TRANSACTION_HISTORY ||
            downloadType === 'case') &&
          caseId
        ) {
          // Signal to DownloadTransactionsDrawer on take-action page to refresh
          // Store notification trigger time keyed by caseId
          sessionStorage.setItem(
            `download_refresh_${caseId}`,
            JSON.stringify({
              module,
              caseId,
              timestamp: new Date().toISOString()
            })
          );
        }

        const config = notifyConfig[statusLower];
        if (config) {
          notification[config.type]({
            message: config.message,
            description: config.description,
            duration: 8,
            placement: 'topRight',
            onClick: navigateToTarget,
            style: { cursor: 'pointer' }
          });
        }
      },
      onError: (error) => {
        console.warn('Notification stream error:', error);
      }
    });

    serviceRef.current = service;
    service.connect();

    return () => {
      service.disconnect();
    };
  }, [history, moduleId]);

  return null;
};

NotificationListener.propTypes = {
  history: PropTypes.object,
  moduleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

const mapStateToProps = (state) => ({
  moduleId: state.authentication?.currentProductLogin?.moduleId
});

export default connect(mapStateToProps)(withRouter(NotificationListener));
